import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DgPageDeleteComponent } from '../dg-page-delete/dg-page-delete.component';
import { ActionDialogData } from '../dg-actions/models/action-dialog-data.model';
import { DialogData } from 'dg-emp-search-lib';

@Component({
  selector: 'app-dg-page-deleteall',
  templateUrl: './dg-page-deleteall.component.html',
  styleUrls: ['./dg-page-deleteall.component.scss'],
})
export class DgPageDeleteallComponent implements OnInit {
  status: string;
  caseData: any;
  selectedCorr: any;

  constructor(
    private http: HttpClient,
    private dialogRef: MatDialogRef<DgPageDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(MAT_DIALOG_DATA) public appTypeId: any
  ) {}
  onSend(): void {
    this.caseData = this.data;

    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    if (this.data) {
      options['body'] = {
        appTypeId: this.data.appTypeId,
      };
    } else {
      options['body'] = {
        appTypeId: 1,
      };
    }
    this.http.delete('/case-mgmnt/all-sent-case', options).subscribe((s) => {
      this.status = 'Delete successful';
      this.dialogRef.close(true);
    });
  }
  ngOnInit(): void {
    console.log('On init');
  }
}
